import { Outlet } from 'react-router'
import { AdminSidebar } from './AdminSidebar'
import { AdminTopBar } from './AdminTopBar'

export function AdminLayout() {
  return (
    <div className="relative flex h-full w-full overflow-hidden bg-background text-foreground font-base">
      <AdminSidebar />
      <main className="flex h-full min-w-0 flex-1 flex-col overflow-hidden">
        <AdminTopBar />
        <div className="min-h-0 flex-1 overflow-y-auto bg-background">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
